export default __webpack_public_path__ + "static/media/IMG_5379.73d87682.WEBP";